import React from 'react'
import './annc.css'
const Annoucement = () => {
    return (
        <div className="mb-0" style={{backgroundColor:"teal"}}> 
            <p className="text-center " style={{color:"white"}}>Order Cakes today and get Rs 30/- off</p>
        </div>
    )
}

export default Annoucement
